module.exports = __webpack_public_path__ + "img/DNARepair-PDAC_GSE202740.67022391.png";